const ActionTypes = {
  updateItemsVisible: 'updateItemsVisible',
  updateParameters: 'updateParameters',
  clearBlogFilters: 'clearBlogFilters',
  updateFiltersItemsAndKeysUpdate: 'updateFiltersItemsAndKeysUpdate',
  selectBlogFilter: 'selectBlogFilter',
  searchForPosts: 'searchForPosts',
}
const defaultInvisibleItemsLength = 9

export { ActionTypes, defaultInvisibleItemsLength }
